// Shared by the footer dialogs and permanent document pages.
export const LEGAL_REVISION = '2026-09-28';
export const LEGAL_UPDATED_AT = '28 сентября 2026 года';

export const LEGAL_DOCUMENTS = {
  "agreement": {
    "title": "Пользовательское соглашение",
    "shortTitle": "Соглашение",
    "description": "Правила работы с архивом, учётной записью и материалами участников.",
    "sections": [
      {
        "title": "1. Проект и условия использования",
        "paragraphs": [
          "MaximGun (maximgun.ru и его поддомены) — независимый некоммерческий историко-справочный проект. Администратор проекта является владельцем сайта; контакты для обращений приведены ниже и на странице «О проекте».",
          "Настоящее соглашение определяет правила использования функций сайта. При создании учётной записи пользователь принимает его отдельной отметкой в форме. Принятие соглашения и ознакомление с политикой данных не заменяют отдельного согласия на обработку персональных данных, когда оно требуется."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "2. Назначение архива",
        "paragraphs": [
          "Материалы предназначены для исторических, исследовательских, музейных, коллекционных, образовательных и справочных целей. Сайт не является магазином, торговой площадкой, государственным реестром или экспертной организацией.",
          "Датировки, определения и сведения о предметах могут уточняться. Они не являются официальным заключением о подлинности, происхождении, стоимости, безопасности или правовом статусе предмета. Использование информации должно соответствовать применимому законодательству."
        ]
      },
      {
        "title": "3. Учётная запись и доступность функций",
        "paragraphs": [
          "Для учётной записи используются логин, адрес электронной почты и пароль. Пользователь указывает доступный ему email, сохраняет пароль в тайне и сообщает администратору о подозрении на посторонний доступ.",
          "Регистрация, вход, подтверждение email и восстановление доступа могут быть временно недоступны или работать с ограничениями. Неполучение письма не означает, что данные отправленной регистрационной формы не были сохранены. Порядок обработки и удаления данных описан в политике.",
          "Просмотр открытых материалов архива не требует регистрации."
        ]
      },
      {
        "title": "4. Предоставление материалов",
        "paragraphs": [
          "Отправляя фотографии, тексты и исправления, участник указывает известный источник и автора, отделяет предположения от подтверждённых сведений и сообщает об ограничениях на публикацию. Нельзя предоставлять материалы с нарушением авторских прав, конфиденциальности или прав изображённых лиц.",
          "В отношении собственных материалов, переданных для публикации, участник предоставляет администратору безвозмездную простую (неисключительную) лицензию на воспроизведение и размещение в интернете в составе архива, включая техническое изменение размера и формата. Лицензия действует на территории всех стран в течение срока размещения материала; авторство и согласованные ограничения сохраняются. Условия удаления или изменения публикации можно обсудить с администратором.",
          "Для чужих материалов участник должен иметь право разрешить такое использование либо указать применимое законное основание. Одна ссылка на источник не заменяет разрешение правообладателя."
        ]
      },
      {
        "title": "5. Публикация и права третьих лиц",
        "paragraphs": [
          "Администратор рассматривает присланные материалы и вправе запросить уточнения, исправить оформление, отложить или отклонить публикацию. Отправка материала не гарантирует его размещение.",
          "Не публикуйте чужие контакты, адреса частных коллекций и другие персональные сведения без надлежащего основания. Авторские права на фотографии и тексты сохраняются за соответствующими правообладателями; размещение в архиве не означает разрешения на любое дальнейшее использование.",
          "Правообладатель или лицо, чьи права затронуты, может сообщить ссылку на материал, суть обращения и сведения, позволяющие проверить его права. По результатам рассмотрения подпись, авторство или публикация могут быть исправлены либо материал удалён."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "6. Правила безопасности",
        "items": [
          "Не пытаться получить доступ к чужой учётной записи или закрытым функциям сайта.",
          "Не распространять вредоносный код, заведомо ложные сведения или запрещённые материалы.",
          "Не создавать чрезмерную нагрузку на сайт и не вмешиваться в работу его сервисов.",
          "Соблюдать права авторов, участников проекта и других лиц."
        ]
      },
      {
        "title": "7. Ограничение доступа и ответственность",
        "paragraphs": [
          "Администратор может ограничить доступ при нарушениях, угрозах безопасности, технических работах или требованиях закона. Сайт развивается как исследовательский проект; безошибочность сведений и непрерывная доступность всех функций не гарантируются.",
          "Каждая сторона несёт ответственность в пределах, установленных законом. Соглашение не исключает ответственность, которая не может быть исключена или ограничена договором."
        ]
      },
      {
        "title": "8. Изменения и обращения",
        "paragraphs": [
          "Актуальная редакция доступна по постоянной ссылке с датой обновления. Изменение соглашения само по себе не расширяет ранее данное согласие на обработку персональных данных.",
          "Вопросы о работе архива, правах на материалы и учётной записи можно направить администратору."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      }
    ]
  },
  "privacy": {
    "title": "Политика обработки персональных данных",
    "shortTitle": "Персональные данные",
    "description": "Данные посетителей и участников, аналитика, хранение и порядок обращений.",
    "sections": [
      {
        "title": "1. Область действия и оператор",
        "paragraphs": [
          "Политика описывает обработку данных посетителей и участников проекта MaximGun на maximgun.ru и его поддоменах: при просмотре страниц, использовании учётной записи, отправке материалов, исправлений и обращений.",
          "Оператором является физическое лицо — владелец и администратор проекта MaximGun, которое определяет цели и способы обработки данных. Обращения по персональным данным, включая отзыв согласия и запрос на удаление аккаунта, можно направить через Telegram @noglef_qa. Дополнительные контакты опубликованы на странице «О проекте».",
          "Политика информирует о фактической обработке. Её публикация и просмотр сайта сами по себе не являются отдельным согласием пользователя."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "2. Какие данные обрабатываются",
        "items": [
          "Посетители: IP-адрес, сведения о браузере и устройстве, адреса посещаемых страниц, источник перехода и действия на сайте, а также идентификаторы браузера, используемые Яндекс.Метрикой.",
          "Владельцы аккаунтов: логин, email, хеш пароля, роль, статус подтверждения и служебные данные авторизации, подтверждения email и восстановления доступа. Пароль передаётся для регистрации или проверки входа; в базе аккаунтов хранится его хеш.",
          "Участники архива: содержание отправленных материалов и исправлений, фотографии и подписи, связь заявки с учётной записью, даты отправки и рассмотрения, статус и результат модерации.",
          "Авторы обращений: содержание сообщения, предоставленные контактные данные и сведения, необходимые для ответа.",
          "В браузере сохраняются данные авторизации и настройки интерфейса. Их назначение описано в документе «Cookies и браузерное хранилище»."
        ],
        "paragraphs": [
          "Для просмотра архива не требуется сообщать ФИО, телефон, паспортные сведения или адрес проживания. Не отправляйте через формы сведения, не нужные для соответствующей задачи."
        ]
      },
      {
        "title": "3. Цели обработки",
        "items": [
          "Работа учётной записи: регистрация, подтверждение email, вход и восстановление доступа.",
          "Работа с архивом: приём и рассмотрение материалов и исправлений, взаимодействие с их отправителями.",
          "Работа сайта: сохранение выбранных настроек, доставка запрошенных страниц и обеспечение безопасности доступа.",
          "Аналитика: оценка посещаемости, источников переходов, востребованности материалов и удобства сайта с помощью Яндекс.Метрики.",
          "Рассмотрение обращений, защита прав участников и правообладателей, исполнение обязанностей, установленных законом."
        ]
      },
      {
        "title": "4. Правовые основания и согласие",
        "paragraphs": [
          "При определении оснований обработки применяются Федеральный закон № 152-ФЗ «О персональных данных», другие применимые нормы законодательства, пользовательское соглашение и отдельно предоставленное согласие в пределах соответствующих целей.",
          "Для регистрации используется отдельная отметка о согласии на обработку данных аккаунта. Обработка, необходимая для исполнения соглашения с пользователем, может осуществляться на предусмотренном законом договорном основании. Для иных целей должно существовать самостоятельное применимое правовое основание.",
          "Согласие на данные аккаунта не распространяется автоматически на аналитику, рекламу или публикацию персональных данных. Настоящая политика не заменяет согласие там, где оно требуется законом."
        ]
      },
      {
        "title": "5. Яндекс.Метрика",
        "paragraphs": [
          "На сайте подключён сервис Яндекс.Метрика. Счётчик загружается автоматически при открытии страницы и получает технические сведения о посещении, включая данные устройства, браузерные идентификаторы, просмотренные страницы и переходы по ссылкам. Ожидание выбора в отдельном окне согласия в текущей версии сайта не предусмотрено.",
          "Для различения посещений сервис использует cookies и localStorage. Администратору доступны отчёты о посещаемости и активности. Наличие статистических отчётов не означает, что при сборе вообще не обрабатываются персональные данные.",
          "Порядок обработки со стороны поставщика сервиса описан в документах Яндекса. Способы ограничения сбора указаны в документе о cookies и в справке о Блокировщике Яндекс.Метрики."
        ],
        "links": [
          {
            "label": "Условия использования Яндекс.Метрики",
            "href": "https://yandex.ru/legal/metrica_termsofuse/ru/"
          },
          {
            "label": "Политика конфиденциальности Яндекса",
            "href": "https://yandex.ru/legal/confidential/ru/"
          },
          {
            "label": "Блокировщик Яндекс.Метрики",
            "href": "https://yandex.ru/support/metrica/ru/general/opt-out"
          }
        ]
      },
      {
        "title": "6. Способы обработки и получатели",
        "paragraphs": [
          "Данные обрабатываются с использованием средств автоматизации, а обращения и материалы также рассматриваются администратором и уполномоченными модераторами. В зависимости от цели выполняются сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, предоставление необходимого доступа, блокирование, удаление и уничтожение.",
          "Основная база данных сайта и почтовый сервер размещены в Российской Федерации. Доступ технических поставщиков определяется необходимостью предоставления хостинга, хранения и доставки служебных сообщений и условиями соответствующих договоров.",
          "При использовании Метрики сведения о посещениях передаются поставщику сервиса Яндекс. При обращении через Telegram сведения также обрабатываются соответствующим сервисом связи по его правилам.",
          "Логин, email, хеш пароля и служебные данные входа не предназначены для открытой публикации. Предоставленные для архива материалы публикуются с учётом прав и согласованных условий. Данные также могут предоставляться по предусмотренным законом требованиям уполномоченных органов."
        ]
      },
      {
        "title": "7. Сроки хранения и прекращение обработки",
        "paragraphs": [
          "Данные аккаунта обрабатываются в течение его существования, пока необходимы для соответствующих целей и имеется законное основание. Материалы заявок и история их рассмотрения сохраняются на период работы с публикацией и разрешения связанных обращений.",
          "Служебные токены имеют ограниченный срок действия. Недоставка письма или истечение срока токена сами по себе не означают удаления неподтверждённой учётной записи.",
          "При достижении цели, отзыве согласия или поступлении требования о прекращении обработки оператор оценивает основания дальнейшего хранения и прекращает обработку, удаляет либо блокирует данные в порядке и сроки, установленные законом. При наличии самостоятельного законного основания отдельные сведения могут сохраняться и после отзыва согласия.",
          "Удаление распространяется на используемые оператором копии данных с учётом установленного законом порядка и применяемой системы резервного копирования. Сроки действия браузерных cookies указаны в документе о cookies; удаление cookie в браузере не удаляет ранее собранные серверные сведения."
        ]
      },
      {
        "title": "8. Защита данных",
        "paragraphs": [
          "Для аккаунтов используется хранение хешей паролей, проверка авторизации и разграничение доступа по ролям. Доступ к закрытым данным предоставляется в пределах задач администрирования и модерации. Оператор должен обеспечивать необходимые организационные и технические меры защиты в соответствии с законодательством.",
          "Пользователю следует сохранять пароль в тайне и завершать сеанс на общедоступных устройствах. О подозрении на посторонний доступ можно сообщить администратору; передавать пароль в сообщении не нужно."
        ]
      },
      {
        "title": "9. Права и обращения",
        "paragraphs": [
          "Пользователь вправе получить сведения об обработке своих данных, потребовать исправления неточных сведений, блокирования или удаления данных при наличии предусмотренных законом оснований, отозвать согласие, а также обратиться в Роскомнадзор или суд.",
          "В обращении укажите характер запроса и сведения, позволяющие найти соответствующий аккаунт, заявку или публикацию. Для защиты данных администратор может запросить необходимое подтверждение, что обращение исходит от их субъекта. Не присылайте пароль или копии документов без обоснованной необходимости.",
          "Запрос можно направить через Telegram @noglef_qa, в том числе при недоступности почты. Он рассматривается в предусмотренные законом сроки. Удаление данных, необходимых для аккаунта, может сделать дальнейший вход невозможным."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "10. Редакции политики",
        "paragraphs": [
          "Дата редакции указана в начале документа. При изменении функций сайта, состава данных или условий обработки политика обновляется. Новая редакция не означает автоматического получения нового согласия или расширения ранее предоставленного согласия."
        ]
      }
    ]
  },
  "consent": {
    "title": "Согласие на обработку персональных данных",
    "shortTitle": "Согласие",
    "description": "Отдельное согласие для учётной записи и участия в работе архива.",
    "sections": [
      {
        "title": "1. Как предоставляется согласие",
        "paragraphs": [
          "Отмечая отдельный пункт «Даю согласие на обработку персональных данных» и отправляя регистрационную форму, я свободно, своей волей и в своём интересе даю владельцу и администратору проекта MaximGun согласие на обработку перечисленных ниже данных в указанных целях.",
          "Согласие предоставляется отдельно от принятия пользовательского соглашения и ознакомления с политикой. Просмотр этого документа или страниц сайта не является его предоставлением. Контакт оператора для вопросов и отзыва согласия: Telegram @noglef_qa."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "2. Данные и цели",
        "items": [
          "Логин, email и пароль, преобразуемый для хранения в хеш: создание и подтверждение аккаунта, проверка входа и восстановление доступа.",
          "Роль, статус подтверждения, служебные токены: обеспечение работы и безопасности учётной записи.",
          "Данные, которые я отправлю как участник архива: содержание заявок, фотографий, подписей и исправлений, связь с аккаунтом и история рассмотрения — для приёма, модерации и обсуждения этих материалов.",
          "Содержание моих обращений по аккаунту и предоставленные контакты — для рассмотрения обращения и ответа."
        ]
      },
      {
        "title": "3. Действия и способы",
        "paragraphs": [
          "Разрешаю сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, блокирование, удаление и уничтожение указанных данных с использованием средств автоматизации и при рассмотрении материалов администратором и уполномоченными модераторами.",
          "Основная база аккаунтов и почтовый сервер находятся в Российской Федерации. Работа инфраструктуры и возможный доступ технических поставщиков описаны в политике обработки персональных данных; передача данных другим лицам требует надлежащего правового основания."
        ]
      },
      {
        "title": "4. Срок и отзыв",
        "paragraphs": [
          "Согласие действует с момента его предоставления до достижения соответствующих целей, удаления учётной записи или отзыва согласия. Для отзыва можно направить администратору сообщение через Telegram @noglef_qa с просьбой прекратить обработку и сведениями, позволяющими определить аккаунт или материал.",
          "После отзыва обработка прекращается в предусмотренном законом порядке, если для её продолжения нет самостоятельного законного основания. Прекращение обработки данных, необходимых для аккаунта, может сделать вход и участие через него невозможными."
        ],
        "links": [
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "5. Границы согласия",
        "paragraphs": [
          "Это согласие не распространяется на рекламные рассылки, сбор данных Яндекс.Метрикой или публичное распространение моих персональных данных. Вопросы публикации предоставленных материалов регулируются отдельно с учётом авторских прав и требований к распространению персональных данных.",
          "Информация об аналитике доступна в политике и документе о cookies. Неполучение письма подтверждения не отменяет факт отправки формы и не означает автоматического удаления переданных данных."
        ]
      }
    ]
  },
  "cookies": {
    "title": "Cookies и браузерное хранилище",
    "shortTitle": "Cookies",
    "description": "Настройки сайта, данные авторизации и аналитика Яндекс.Метрики.",
    "sections": [
      {
        "title": "1. Какие технологии используются",
        "paragraphs": [
          "Cookie — небольшая запись, которую браузер хранит для сайта и может передавать при запросах. localStorage и sessionStorage — другие виды браузерного хранилища: они используются кодом страницы и не являются cookies.",
          "MaximGun использует браузерное хранилище для авторизации, настроек и навигации. Подключённая Яндекс.Метрика дополнительно использует cookies и собственные записи в хранилище."
        ]
      },
      {
        "title": "2. Хранилище самого сайта",
        "items": [
          "localStorage, запись auth: токен авторизации, логин и роль. Используется для сохранения входа; удаляется при выходе из аккаунта или очистке данных сайта. Истечение токена прекращает его пригодность для входа, но не обязательно сразу удаляет запись из браузера.",
          "localStorage, настройки siteTheme, articleTheme, siteLanguage, articlesLang и lang: выбранная тема и язык. Настройки просмотра фотографий также могут сохраняться в этом хранилище.",
          "sessionStorage: положение прокрутки, временные данные просмотренных карточек и отметки о просмотрах статей в текущей сессии вкладки."
        ],
        "paragraphs": [
          "У записей localStorage нет общего автоматического срока удаления: они сохраняются до изменения, удаления приложением, пользователем или браузером. sessionStorage обычно очищается при завершении сессии вкладки; поведение при восстановлении вкладок зависит от браузера.",
          "Очистка данных сайта может сбросить вход, язык, тему и сохранённое положение страницы."
        ]
      },
      {
        "title": "3. Аналитика Яндекс.Метрики",
        "paragraphs": [
          "Счётчик Метрики загружается автоматически при посещении сайта. Он используется для анализа посещаемости, источников переходов, просмотра страниц, кликов и переходов по ссылкам. Сведения о визитах передаются Яндексу.",
          "Метрика применяет браузерные идентификаторы. В зависимости от браузера и настроек сервиса могут устанавливаться, в частности, следующие cookies:"
        ],
        "items": [
          "_ym_uid — идентификатор посетителя; срок по справке Яндекса — 1 год.",
          "_ym_d — дата первого посещения.",
          "_ym_isad — проверка наличия блокировщика рекламы; 20 часов.",
          "_ym_metrika_enabled — проверка работы cookies; 60 минут."
        ],
        "after": [
          "Это примеры, а не исчерпывающий перечень. Метрика также может использовать записи localStorage, включая _ym_uid и служебные записи с префиксом _ym. Состав и сроки зависят от настроек сервиса и могут обновляться Яндексом; актуальные сведения доступны в его справке."
        ],
        "links": [
          {
            "label": "Файлы cookies и хранилище Яндекс.Метрики",
            "href": "https://yandex.ru/support/metrica/ru/general/cookie-usage"
          },
          {
            "label": "Условия использования Метрики",
            "href": "https://yandex.ru/legal/metrica_termsofuse/ru/"
          }
        ]
      },
      {
        "title": "4. Как ограничить сбор",
        "paragraphs": [
          "В поддерживаемом браузере можно установить Блокировщик Яндекс.Метрики или использовать средства блокировки аналитических запросов. Это может ограничить дальнейшую отправку сведений в Метрику; само по себе удаление cookies не прекращает загрузку счётчика при следующем посещении.",
          "В настройках браузера можно удалить данные сайта и ограничить сохранение cookies. Блокировка только сторонних cookies не гарантирует отключения Метрики, поскольку сервис также использует хранилище на домене сайта.",
          "Ограничение работы Метрики не требует создания аккаунта. Удаление браузерных записей не удаляет данные учётной записи и ранее переданные сведения на серверах. По вопросам обработки и удаления можно обратиться к администратору."
        ],
        "links": [
          {
            "label": "Блокировщик Яндекс.Метрики",
            "href": "https://yandex.ru/support/metrica/ru/general/opt-out"
          },
          {
            "label": "Связаться с администратором: Telegram @noglef_qa",
            "href": "https://t.me/noglef_qa"
          }
        ]
      },
      {
        "title": "5. Связь с другими документами",
        "paragraphs": [
          "Состав данных, цели обработки и права пользователя дополнительно описаны в политике обработки персональных данных. Этот документ объясняет использование хранилища и не является согласием пользователя на обработку данных.",
          "Дата редакции указана в начале документа. Описание обновляется при изменении используемых технологий."
        ]
      }
    ]
  }
};

export function getLegalDocument(key) {
  return Object.prototype.hasOwnProperty.call(LEGAL_DOCUMENTS, key)
    ? LEGAL_DOCUMENTS[key]
    : null;
}
